import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, filter } from 'lodash';

import ArticleCards from '~/components/blocks/acf/ArticleCards';

import { AcfLink, AcfBackgroundColor } from '~/utilities/propTypes';

import { useAllPosts } from '~/hooks/useAllPosts';

const NewsCardsBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockNewsCards: { link, backgroundColor, select, category, cards }
}) => {
    const posts = useAllPosts();

    let featuredPosts = [];

    if (select && cards?.length) {
        featuredPosts = cards;
    } else if (!select && !isEmpty(category)) {
        featuredPosts = filter(posts, ({ categories: { nodes } }) =>
            nodes?.length ? nodes[0].id === category.id : false
        ).slice(0, 2);
    }

    return (
        <ArticleCards
            {...{
                attributes,
                globalBlockOptions,
                link,
                backgroundColor
            }}
            numberOfColumns={2}
            largeTitle
            cards={featuredPosts}
        />
    );
};

NewsCardsBlock.propTypes = {
    blockNewsCards: PropTypes.shape({
        link: AcfLink,
        ...AcfBackgroundColor,
        select: PropTypes.bool,
        category: PropTypes.shape({}),
        cards: PropTypes.arrayOf(PropTypes.shape({}))
    }).isRequired
};

export default NewsCardsBlock;

export const fragment = graphql`
    fragment NewsCardsBlockFragment on WpAcfNewsCardsBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockNewsCards {
            link {
                title
                url
            }
            backgroundColor
            select
            category {
                id
                slug
                name
            }
            cards {
                ... on WpPost {
                    id
                    title
                    uri
                    excerpt
                    featuredImage {
                        node {
                            altText
                            sourceUrl
                        }
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default News Cards',
        description:
            'White or Light Blue background color. Optional Title/Link. Option to select individual posts or select a category that will use the 2 most recent posts from that category.',
        props: {
            name: 'acf/news-cards',
            blockNewsCards: {
                link: {
                    title: 'The Title',
                    url: '#1'
                },
                backgroundColor: 'white',
                select: false,
                category: {
                    id: 'dGVybToxMDQ=',
                    slug: 'the-blog',
                    name: 'The Blog'
                }
            }
        }
    },
    {
        variant: 'Individual Post News Cards',
        description: 'Light Blue Background using single post selection.',
        props: {
            name: 'acf/news-cards',
            blockNewsCards: {
                link: {
                    title: 'The Blog',
                    url: '#4'
                },
                backgroundColor: 'lightBlue',
                select: true,
                cards: [
                    {
                        id: 123,
                        title: 'Post Title',
                        uri: '#2',
                        excerpt:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                        featuredImage: {
                            node: {
                                id: '123',
                                sourceUrl:
                                    'https://picsum.photos/850/600?random=1'
                            }
                        }
                    },
                    {
                        id: 124,
                        title: 'Post Title 2',
                        uri: '#3',
                        excerpt:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        featuredImage: {
                            node: {
                                id: '124',
                                sourceUrl:
                                    'https://picsum.photos/850/600?random=2'
                            }
                        }
                    }
                ]
            }
        }
    }
];
